import { some, startsWith } from 'lodash';
import { isRootNode } from '../common/components/dataViews/DynamicTree';
export const LIBRARY = 'EContentLibrary';
export const FOLDER = 'EContentFolder';
export const RESOURCE = 'EContentResource';
export const isEContentLibraryFolder = node => (node === null || node === void 0 ? void 0 : node.__typename) === FOLDER;
export const isEContentLibraryResource = node => (node === null || node === void 0 ? void 0 : node.__typename) === RESOURCE;
export const isEContentLibrary = node => (node === null || node === void 0 ? void 0 : node.__typename) === LIBRARY;
export const resolveNodeId = ({ __typename, id }) => `${__typename}-${id}`;
export const resolveNodeParentIdWithLibrary = node => {
    const { parentId, folderId, libraryId } = node;
    switch (true) {
        case isEContentLibraryFolder(node) && !!parentId:
            return `${FOLDER}-${parentId}`;
        case isEContentLibraryFolder(node) && !!libraryId:
            return `${LIBRARY}-${libraryId}`;
        case isEContentLibraryResource(node) && !!folderId:
            return `${FOLDER}-${folderId}`;
        case isEContentLibraryResource(node) && !!libraryId:
            return `${LIBRARY}-${libraryId}`;
        default:
            return null;
    }
};
export const resolveNodeParentId = node => {
    const { parentId, folderId } = node;
    switch (true) {
        case isEContentLibraryFolder(node) && !!parentId:
            return `${FOLDER}-${parentId}`;
        case isEContentLibraryResource(node) && !!folderId:
            return `${FOLDER}-${folderId}`;
        default:
            return null;
    }
};
export const resolveNodeClassName = node => {
    if (isRootNode(node) || isEContentLibrary(node)) {
        return 'jstree-node-bold';
    }
    if (isEContentLibraryResource(node)) {
        return 'jstree-node-italic';
    }
    return '';
};
export const canRender = ({ id, model, leaf, nodesMeta: { hasChild }, state, }) => {
    const checkLeafExistsRecursively = (nodeId) => {
        if (!state.children[nodeId] || !state.children[nodeId].length) {
            return false;
        }
        const leafExists = some(state.children[nodeId], str => startsWith(str, RESOURCE) &&
            !Object.keys(state.hiddenNodeIds).find(x => x === str));
        if (leafExists) {
            return true;
        }
        return some(state.children[nodeId], childId => checkLeafExistsRecursively(childId));
    };
    if ((model.id !== ':ROOT:' || model.id !== null) &&
        !isEContentLibraryResource(model)) {
        if (state.children[id]) {
            const leafExists = checkLeafExistsRecursively(id);
            if (!leafExists || leaf) {
                return false;
            }
        }
        else {
            return false;
        }
    }
    return true;
};
